<i18n locale="en">
{
  "input-labels": {
    "title": "Title",
    "description": "Description",
    "images": "Gallery Images",
    "image-cropper": "Gallery Image"
  }
}
</i18n>

<template>
  <OwnStack spacing="8">
    <OwnInputContainer
      :label="$t('input-labels.title')"
      :errors="title.status.errors"
    >
      <OwnInput v-model="title.value" :placeholder="$t('input-labels.title')" />
    </OwnInputContainer>
    <OwnInputContainer
      :label="$t('input-labels.description')"
      :errors="description.status.errors"
    >
      <OwnInput
        v-model="description.value"
        :placeholder="$t('input-labels.description')"
      />
    </OwnInputContainer>
    <OwnInputContainer :label="$t('input-labels.images')">
      <MultiImageInput
        :aspect-ratio="1"
        :value="currentBlockParams.images"
        :label="$t('input-labels.image-cropper')"
        @change="onChange"
      />
    </OwnInputContainer>
  </OwnStack>
</template>

<script>
import { mapGetters } from 'vuex'

import { MultiImageInput } from '@/components/inputs'
import { FormBuilder, Validators } from '@/forms'
import { logWarn } from '@/logger'
import { OwnInputContainer, OwnInput, OwnStack } from '@/ui'

import { GalleryCommands } from '../commands/GalleryCommands'

export default {
  name: 'GalleryEditor',
  components: {
    MultiImageInput,
    OwnInput,
    OwnInputContainer,
    OwnStack,
  },
  mixins: [
    FormBuilder({
      description: {
        debounce: 250,
        validateOnInit: true,
        validators: [],
      },
      title: {
        debounce: 250,
        validateOnInit: true,
        validators: [Validators.required],
      },
    }),
  ],
  props: {
    /**
     * Id getting passed to the editor component
     */
    id: { type: String, required: true },
  },
  computed: {
    ...mapGetters({
      blockById: 'websiteBuilder/blockById',
    }),
    currentBlockParams() {
      const { id } = this

      return this.blockById(id)?.params
    },
  },
  created() {
    const { currentBlockParams } = this

    this.setInitialFormValues({
      description: currentBlockParams.description,
      title: currentBlockParams.title,
    })
  },
  methods: {
    fireAnalyticsEvent(type) {
      switch (type) {
        case 'upload':
          this.$analytics.track('Gallery Image Added')
          break
        case 'remove':
          this.$analytics.track('Gallery Image Removed')
          break
        case 'reorder':
          this.$analytics.track('Gallery Images Reordered')
          break
        default:
          logWarn(`Gallery Editor - Unsupported analytics event: ${type}`)
      }
    },
    async onChange({ type, data }) {
      const { id } = this

      await GalleryCommands.updateBlock({
        targetId: id,
        update: {
          params: {
            images: data,
          },
        },
      })

      this.fireAnalyticsEvent(type)
    },
    async onFormControlUpdate(controlName, value) {
      const { id } = this

      if (controlName === 'title') {
        await GalleryCommands.updateBlock({
          targetId: id,
          update: {
            params: {
              title: value,
            },
          },
        })
      }

      if (controlName === 'description') {
        await GalleryCommands.updateBlock({
          targetId: id,
          update: {
            params: {
              description: value,
            },
          },
        })
      }
    },
  },
}
</script>
